export interface FAQItem {
  question: string;
  answer: string;
}

export const faqList: FAQItem[] = [
  {
    question: '牛牛影视是否需要注册才能观看？',
    answer: '不需要注册！牛牛影视全部内容免费观看，无需登录或注册账号，打开网站即可畅享超清画质与不缓冲的流畅播放体验。我们始终坚持以用户体验为核心。',
  },
  {
    question: '牛牛超清画质和牛牛极清模式有什么区别？',
    answer: '牛牛超清是标准的高清画质，足以满足大多数观影需求。牛牛极清模式则是我们的旗舰画质方案，采用先进的视频编码技术，在保证流畅不卡顿的前提下提供更加细腻的画面表现，适合大屏幕设备观看。',
  },
  {
    question: '为什么牛牛影视能做到不缓冲流畅播放？',
    answer: '牛牛不缓冲技术是牛牛影视的核心优势。我们自建了分布式CDN加速网络，在全国部署了数百个加速节点，配合智能预加载算法，确保无论您身在何处，都能享受到流畅不卡顿的观影体验。',
  },
  {
    question: '牛牛影视支持哪些设备观看？',
    answer: '牛牛影视全面支持PC电脑、平板、手机等设备访问。响应式设计让您在任意屏幕尺寸下都能获得最佳观影体验。推荐使用Chrome、Safari等主流浏览器获得最佳效果。',
  },
  {
    question: '牛牛影视的内容更新频率如何？',
    answer: '牛牛影视每日更新，电影、电视剧、动漫、综艺等内容实时同步。热播剧集保持与播出平台同步更新，让您不错过任何精彩内容。首页"最新更新"区域可以随时查看最新上线的内容。',
  },
  {
    question: '观看牛牛影视需要安装播放器吗？',
    answer: '完全不需要安装任何播放器或插件！牛牛影视采用H5播放器技术，在浏览器中即可直接播放所有内容，支持倍速播放、画质切换、记忆播放进度等实用功能。',
  },
];